module.exports = __webpack_public_path__ + "static/media/schnittke-and-denisov.5dcda06d.jpg";